import { Avatar, Box, Text } from 'grommet'
import { Down } from 'grommet-icons'
import { DetailAuditTrail, src } from '../../../constants'
import { DropdownBtn } from '../DropdownBtn'

export const AuditTrail = () => {
  return (
    <Box gap={'16px'} pad={{ horizontal: 'medium', top: 'medium' }}>
      <Box direction="row" justify="between" pad={{ horizontal: '12px' }}>
        <Box>
          <DropdownBtn
            dropdownIcon={<Down size="small" />}
            dropdownLabel="Newest"
            margin="0"
            options={[
              {
                handleClick: () => console.log('Active clicked'),
                label: 'Older',
                reverse: true
              },
              {
                handleClick: () => console.log('Inactive clicked'),
                label: 'Newest',
                reverse: true
              }
            ]}
            pad={{ horizontal: '4px', vertical: '5px' }}
            reverse
            secondary
            style={{ border: '0', fontSize: '16px', fontWeight: '500' }}
          />
        </Box>
      </Box>
      <Box gap={'18px'} pad={{ horizontal: '14px' }}>
        {[...Array(3)]?.map((_, index) => (
          <Box border={{ color: '#ddd', side: 'bottom' }} key={index} pad={{ bottom: '18px' }}>
            <Box align="center" direction="row" gap="8px" margin={{ bottom: '12px' }}>
              <Avatar src={src} />
              <Text size="14px" weight="bold">
                {DetailAuditTrail.getName(index)}{' '}
              </Text>
              <Text size="14px">{DetailAuditTrail.getNote(index)} </Text>
              <Text size="14px" weight="bold">
                {DetailAuditTrail.record}{' '}
              </Text>
            </Box>
            <Box pad={{ right: '40px' }}>
              <Text color={'#666'} size="14px">
                {DetailAuditTrail.date}
              </Text>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
